import React from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { Title } from 'react-admin'
import config from '../config'
import { Button } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
    margin: 'auto',
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(10),
    textAlign: 'center',
  },
  illustration: {
    width: '100%',
    objectFit: 'contain',
    height: '300px',
    margin: theme.spacing(2, 0),
  },
}))

const Unauthorized = () => {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <Title title="Non Autorisé" />
      <CardContent>
        <img
          src={`${config.PUBLIC_URL}/img/401.png`}
          alt="Non Autorisé"
          className={classes.illustration}
        />
        <Typography variant="h4" component="h2" gutterBottom>
          Non Autorisé
        </Typography>

        <Typography variant="body1">
          Désolé, vous n'êtes pas autorisé à accéder à cette page. Essayez de
          vous reconnecter ou utilisez un autre compte.
        </Typography>
        <Button
          href={`${window.location.origin}/oauth2/sign_in`}
          variant="contained"
          style={{ marginTop: 10 }}
          color="secondary"
        >
          Connexion
        </Button>
      </CardContent>
    </Card>
  )
}

export default Unauthorized
